import { environment } from '../../../environments/environment';
import { AnalyticsEffects } from '../analytics/analytics.effects';
import { AnnouncementEffects } from '../announcements/announcements.effects';
import { KratosAuthEffects } from '../auth/auth-kratos.effects';
import { ChatsEffects } from '../chats/chats.effects';
import { CheckInTagsEffects } from '../check-in-tags/check-in-tags.effects';
import { CheckInsEffects } from '../check-ins/check-ins.effects';
import { ConversationsEffects } from '../conversations/conversations.effects';
import { KratosCoreEffects } from '../core/core-kratos.effects';
import { CustomerFilesEffects } from '../customer-files/customer-files.effects';
import { CustomerListsEffects } from '../customer-lists/customer-lists.effects';
import { CustomerTeamEffects } from '../customer-team/customer-team.effects';
import { CustomersEffects } from '../customers/customers.effects';
import { DataExportEffects } from '../data-export/data-export.effects';
import { FeedEffects } from '../feed/feed.effects';
import { FeedbackEffects } from '../feedback/feedback.effects';
import { FileUploadEffects } from '../file-upload/file-upload.effects';
import { FilesEffects } from '../files/files.effects';
import { InviteEffects } from '../invite/invite.effects';
import { LocationEffects } from '../location/location.effects';
import { MemberCustomersEffects } from '../member-customers/member-customers.effects';
import { MemoCategoryEffects } from '../memo-categories/memo-categories.effects';
import { MemoriamEffects } from '../memoriams/memoriams.effects';
import { MemosEffects } from '../memos/memos.effects';
import { NotificationsEffects } from '../notifications/notifications.effects';
import { OrganisationEffects } from '../organisations/organisations.effects';
import { ProfileEffects } from '../profile/profile.effects';
import { QuestionsEffects } from '../questions/questions.effects';
import { ReleaseNotesEffects } from '../release-notes/release-notes.effects';
import { RemoteConfigEffects } from '../remote-config/remote-config.effects';
import { RequestsEffects } from '../requests/requests.effects';
import { RouterEffects } from '../router/router.effects';
import { SettingsEffects } from '../settings/settings.effects';
import { SnackBarEffects } from '../snackbar/snackbar.effects';
import { StaffCustomerEffects } from '../staff-customers/staff-customers.effects';
import { MembersEffects } from '../members/members.effects';
import { StatisticsEffects } from '../statistics/statistics.effects';
import { StorageSyncEffects } from '../storage-sync/storage-sync.effects';
import { TenantsEffects } from '../tenants/tenants.effects';
import { RelatedDataEffects } from './related-data.effects';
import { MarketManagementEffects } from '../market-management-category/market-management-category.effects';

export const EFFECTS = [
  AnalyticsEffects,
  AnnouncementEffects,
  KratosAuthEffects,
  KratosCoreEffects,
  ChatsEffects,
  CheckInsEffects,
  CheckInTagsEffects,
  ConversationsEffects,
  CustomerFilesEffects,
  CustomersEffects,
  CustomerTeamEffects,
  CustomerListsEffects,
  DataExportEffects,
  FeedbackEffects,
  FeedEffects,
  FileUploadEffects,
  FilesEffects,
  InviteEffects,
  LocationEffects,
  MarketManagementEffects,
  MemberCustomersEffects,
  MemoCategoryEffects,
  MemoriamEffects,
  MemosEffects,
  NotificationsEffects,
  OrganisationEffects,
  ProfileEffects,
  RelatedDataEffects,
  RemoteConfigEffects,
  RequestsEffects,
  ReleaseNotesEffects,
  RouterEffects,
  SettingsEffects,
  SnackBarEffects,
  StaffCustomerEffects,
  MembersEffects,
  StatisticsEffects,
  StorageSyncEffects,
  TenantsEffects,
  QuestionsEffects,
];
